export default __webpack_public_path__ + "static/media/fiveg-coverage-thumbnail.c7b98c4d.png";